import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardGuard  {

  constructor(
    public authService: AuthService,
    public router: Router) {

  }

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      return true;
    }
    // Do not wipe Cognito/session here — that caused blank screens after Okta SSO
    // when /home briefly failed the login check. Send the user back to login only.
    this.router.navigate(['/'], { replaceUrl: true });
    return false;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return confirm('Discard unsaved changes?');
  }

}
